import { ThemeColors } from 'types/types';
import * as Backend from '/queries/BackendRequest';

const fetchTheme = async (pid: string): Promise<ThemeColors> => {
  const result = await Backend.request<ThemeColors>('get', `/content-public/${pid}/theme/colors`);
  return result.data.data;
};

const getTheme = (pid: string) => ({
  queryKey: ['getTheme', pid],
  queryFn: () => fetchTheme(pid),
  enabled: !!pid,
  gcTime: 1000 * 60 * 60, // 1 hour
  // If the colors don't exist, we don't wanna wait too long to load the app.
  // Furthermore, the theme will load before it validates the project ID.
  // If the project does not exist, this should fail fast so we can redirect
  // to the default project before the user notices.
  // Old value: 1.
  retry: 0,
  retryDelay: 20000,
});

export default getTheme;
